import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { client } from './lib/client';
import './styles.css';

const queries = new QueryClient({
  defaultOptions: {
    // The socket pushes changes, so refetching on every focus is wasted work.
    queries: { staleTime: 60_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const root = createRoot(document.getElementById('root')!);

// `?preview`, `?preview=room`, `?preview=sharing`, `?preview=lobby`, `?preview=login`: development-only screens with fake data.
const preview = import.meta.env.DEV ? new URLSearchParams(location.search).get('preview') : null;
if (preview !== null) {
  const { Preview } = await import('./dev/Preview');
  root.render(<Preview mode={preview} />);
} else {
  void client.session.start();
  root.render(
    <StrictMode>
      <QueryClientProvider client={queries}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
}
